import { render, staticRenderFns } from "./CustomMappingModal.vue?vue&type=template&id=39fe928a&scoped=true&"
import script from "./CustomMappingModal.vue?vue&type=script&lang=js&"
export * from "./CustomMappingModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomMappingModal.vue?vue&type=style&index=0&id=39fe928a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fe928a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39fe928a')) {
      api.createRecord('39fe928a', component.options)
    } else {
      api.reload('39fe928a', component.options)
    }
    module.hot.accept("./CustomMappingModal.vue?vue&type=template&id=39fe928a&scoped=true&", function () {
      api.rerender('39fe928a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ImportMappings/CustomMappingModal.vue"
export default component.exports